export const FETCHING_BLOGS = 'FETCHING_BLOGS';
export const FETCHING_BLOGS_SUCCESSFUL = 'FETCHING_BLOGS_SUCCESSFUL';
export const FETCHING_BLOGS_FAILED = 'FETCHING_BLOGS_FAILED';

export const FETCHING_FEATURED_BLOGS = 'FETCHING_FEATURED_BLOGS';
export const FETCHING_FEATURED_BLOGS_SUCCESSFUL = 'FETCHING_FEATURED_BLOGS_SUCCESSFUL';
export const FETCHING_FEATURED_BLOGS_FAILED = 'FETCHING_FEATURED_BLOGS_FAILED';

export const FETCHING_POPULAR_BLOGS = 'FETCHING_POPULAR_BLOGS';
export const FETCHING_POPULAR_BLOGS_SUCCESSFUL = 'FETCHING_POPULAR_BLOGS_SUCCESSFUL';
export const FETCHING_POPULAR_BLOGS_FAILED = 'FETCHING_POPULAR_BLOGS_FAILED';

export const FETCHING_SINGLE_BLOG = 'FETCHING_SINGLE_BLOG';
export const FETCHING_SINGLE_BLOG_COMPLETE = 'FETCHING_SINGLE_BLOG_COMPLETE';


export const FILTERED_BLOG_TYPE = {
    featured: {
        data: FETCHING_FEATURED_BLOGS,
        failed: FETCHING_FEATURED_BLOGS_FAILED,
        success: FETCHING_FEATURED_BLOGS_SUCCESSFUL,
    },
    popular: {
        data: FETCHING_POPULAR_BLOGS,
        failed: FETCHING_POPULAR_BLOGS_FAILED,
        success: FETCHING_POPULAR_BLOGS_SUCCESSFUL,
    },
}

export const ADDING_BLOGS = 'ADDING_BLOGS';
export const ADDING_BLOGS_FAILED = "ADDING_BLOGS_FAILED";
export const ADDING_BLOGS_SUCCESS = "ADDING_BLOGS_SUCCESS";
